import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Handshake, Save, Lock } from "lucide-react";
import api from "@/lib/api";

/** Orden de compra preferente (licencias de marca blanca, sin condiciones). */
export default function PreferredLabsPage() {
  const [labs, setLabs] = useState(["", "", ""]);
  const [lockedFirst, setLockedFirst] = useState(false);
  const [options, setOptions] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/preferred-labs").then(({ data }) => {
      const l = [...(data.labs || [])];
      while (l.length < 3) l.push("");
      setLabs(l.slice(0, 3));
      setLockedFirst(!!data.locked_first);
    });
    api.get("/catalog/laboratorios").then(({ data }) => {
      setOptions(Array.isArray(data?.labs) ? data.labs : []);
    }).catch(() => {});
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put("/preferred-labs", { labs });
      toast.success("Orden de compra guardado", { description: data.labs.join(" → ") });
    } catch (e) {
      toast.error(e?.response?.data?.detail || "No se pudo guardar");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-6" data-testid="preferred-labs-page">
      <header>
        <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight flex items-center gap-2">
          <Handshake className="h-6 w-6 text-slate-400" strokeWidth={1.5} /> Mis laboratorios
        </h1>
        <p className="text-slate-500 text-sm mt-1">
          Elige a quién comprar por orden de preferencia. Los pedidos se asignarán siguiendo este orden.
        </p>
      </header>

      <section className="bg-white border border-slate-200 rounded-lg p-6 space-y-4 max-w-2xl">
        {[0, 1, 2].map((i) => (
          <div key={i} className="flex items-center gap-3">
            <span className="h-8 w-8 rounded-full bg-slate-900 text-white grid place-items-center text-sm font-bold shrink-0">
              {i + 1}
            </span>
            {i === 0 && lockedFirst ? (
              <div
                className="flex-1 flex items-center gap-2 px-3 py-2.5 border border-slate-200 rounded-lg bg-slate-50 text-sm font-semibold text-slate-700"
                data-testid="preferred-lab-0-locked"
              >
                <Lock className="h-3.5 w-3.5 text-slate-400" /> {labs[0] || "SANDOZ"}
              </div>
            ) : (
              <input
                list="labs-list"
                value={labs[i]}
                onChange={(e) => setLabs((p) => p.map((x, j) => (j === i ? e.target.value : x)))}
                placeholder={`Laboratorio ${i + 1}`}
                className="flex-1 px-3 py-2.5 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-slate-900"
                data-testid={`preferred-lab-${i}`}
              />
            )}
          </div>
        ))}
        <datalist id="labs-list">
          {options.map((o) => (
            <option key={typeof o === "string" ? o : o.laboratorio} value={typeof o === "string" ? o : o.laboratorio} />
          ))}
        </datalist>
        <button
          onClick={save}
          disabled={saving}
          className="inline-flex items-center gap-2 bg-slate-900 hover:bg-slate-800 disabled:opacity-60 text-white px-5 py-2.5 rounded-lg text-sm font-bold"
          data-testid="preferred-labs-save"
        >
          <Save className="h-4 w-4" /> Guardar orden
        </button>
      </section>
    </div>
  );
}
